<div class="login-body">
  <div class="login-image" [ngStyle]="background" (click)="calculateBackground()"></div>
  <div class="card login-panel container-fluid">
    <div class="login-panel-content">
      <form #f="ngForm" (ngSubmit)="validate()">
        <div class="login-spiner" *ngIf="show_spin" aria-hidden="true">
          <div class="nb-spinner" role="status">
            <span class="sr-only">...</span>
          </div>
        </div>
        <div class="row">
          <div class="col-3" style="text-align:left;">
            <img src="assets/img/icon-login.svg" />
          </div>
          <div class="col-9" style="text-align:right;">
            <h2 class="welcome-text">{{ 'LoginView.welcome' | translate }}</h2>
            <span class="guest-sign-in">{{'TwoFactor.login' | translate}}</span>
          </div>
          <div class="col-12 p-2" style="text-align:left;">
            <label class="login-label">{{ 'LoginView.verificationCode' | translate }}</label>
            <div class="login-input">
              <input pInput id="verificationCode" name="verificationCode" type="text" [(ngModel)]="user2faCode"
                [ngModelOptions]="{ standalone: true }" autofocus autocapitalize="off" tabindex="1" />
            </div>
          </div>
          <div class="col-3 p-2">
            <button class="btn btn-light btn-lg btn-block" type="button" aria-expanded="false"
              (debounceClick)="logout()" appDebounceClick>
              <i class="fas fa-chevron-left" aria-hidden="true"></i>
              <span class="d-none d-md-inline"> {{ 'Navigation.start' | translate }}</span>
            </button>
          </div>
          <div class="col-9 p-2">
            <button pButton tabindex="2" type="button" class="btn btn-primary  btn-lg btn-block"
              [disabled]="!user2faCode" appDebounceClick (debounceClick)="validate()"> {{ 'General.validate'
              | translate }} </button>
          </div>
          <div class="col-12 p-2 text-center" *ngIf="errorMsg">
            <span class="text-danger">
              <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ errorMsg }}</span>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>